// extracted by mini-css-extract-plugin
export default {"option":"OptionSelect_option__ynril","focado":"OptionSelect_focado__o-bQQ"};